import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ToastService {
  public APP_CONTEXT = 'APP_CONTEXT';
  public MODAL_CONTEXT = 'MODAL_CONTEXT';

  public notice = new BehaviorSubject<any>(null);
  constructor(private translateService?: TranslateService) {}

  showOk(textParam?: any, durationParam?: any, buttonClose?: any, iconParam?: any, context?: any): void {
    const configuration = {
      type: 'success',
      text: textParam ? textParam : this.translateService.instant('notice.successMessage'),
      icon: iconParam ? iconParam : 'glicon-circle-check',
      duration: durationParam ? durationParam : 3000,
      buttonClose: buttonClose ? buttonClose : false,
      context: context ? context : this.APP_CONTEXT
    };
    this.notice.next(configuration);
  }

  showError(error: any, durationParam?: any, buttonClose?: any, iconParam?: any, context?: any): void {
    const configuration = {
      type: 'error',
      text: this.getFormErrorMessage(error),
      icon: iconParam ? iconParam : '',
      duration: durationParam ? durationParam : null,
      buttonClose: buttonClose ? buttonClose : false,
      context: context ? context : this.APP_CONTEXT
    };
    this.notice.next(configuration);
  }

  private getFormErrorMessage(error: any) {
    const message = this.translateError(error.serverMessage, error.payload, error.responseStatusMessage);
    return message;
  }

  private translateError(serverMessage: string | string[], payload: any, defaultMessage: any): any {
    let message = this.translateService.instant(serverMessage, payload);
    if (message === serverMessage) {
      // If the value returned by the translator is the serverMessage itself, that means that it was not found so
      // the message received from the server will be the message displayed on the screen
      message = defaultMessage;
    }
    return message;
  }

  clearNotice(): void {
    this.notice.next(null);
  }
}
